import { v4 as uuidv4 } from 'uuid';
import Utils from '@/common/utils/utils';
import { I18n } from 'aws-amplify';
import Constant from '@/common/constant/Constant';
import MessageCode from '@/common/constant/MessageCode';
import { handleUpdateProjectResource } from '@/service/projectService';
import { cloneDeep } from 'lodash';
import localStorageUtil from '@/common/utils/localStorageUtil';

export const onChangeProjectName = (newProjectName, setProjectName, setIsEdited) => {
    setProjectName(newProjectName);
    setIsEdited(true);
}


export const changeProjectName = (newProject, setProjectName, error, setError, setIsEdited) => {
    let errorObject = { ...error };
    let errorMsg = ''
    setProjectName(newProject);

    if (!newProject.trim()) {
        errorMsg = I18n.get('MSG-CM-REQUIRED-INPUT');
    } else if (newProject.length > 200) {
        errorMsg = I18n.get('COMMSG022').replace('{{maxLength}}', '200');
    }

    errorObject['projectName'] = errorMsg;
    setError(errorObject);

    if (errorMsg) {
        return;
    }
    setIsEdited(true);
}

export const getValueProjectServiceType = (project) => {
    if (!project.isDesk) {
        return Constant.PROJECT_SERVICE_TYPE.DESK_OFF;
    } else {
        return !project.isPublic ? Constant.PROJECT_SERVICE_TYPE.DESK_ON_PUBLIC_OFF : Constant.PROJECT_SERVICE_TYPE.DESK_ON_PUBLIC_ON;
    }
}

export const onChangeProjectServiceType = (event, projectType, setProjectType, setIsEdited) => {
    setIsEdited(true);
    if (event.target.value !== projectType) {
        setProjectType(event.target.value);
    }
}

export const getInitTelephoneAgentSetting = (projectInuseDetail) => {
    const projectSetting = Utils.convertJSONDataToObject(projectInuseDetail?.projectSetting);
    const telephoneAgentSetting = projectSetting?.telephoneAgentSetting;

    const initIsUsingTelephoneAgent = Boolean(telephoneAgentSetting?.isUsingTelephoneAgent);

    let initPhoneNumber = Utils.convertJSONDataToObject(telephoneAgentSetting?.phoneNumbers);
    if (!Array.isArray(initPhoneNumber)) {
        initPhoneNumber = [];
    }

    initPhoneNumber = initPhoneNumber.map(number => ({
        id: `${uuidv4()}`,
        tel: number.tel,
        dialCode: number.dialCode
    }));

    return { initIsUsingTelephoneAgent, initPhoneNumber }
}

const isInputTelephoneEmpty = (dialCode, number) => {
    if (!number) return true;            
    if (number === dialCode) return true;
    return false;                        
};

export const validateSubmitProjectProfile = (error, projectType, isUsingTelephoneAgent, phoneNumbers) => {
    const validateBeforeSubmit = validateInputProjectProfile(error, projectType);
    let isEmptyPhoneInput = false;
    
    // Phone number validation only applies for DESK_ON_PUBLIC_ON project type
    if (projectType === Constant.PROJECT_SERVICE_TYPE.DESK_ON_PUBLIC_ON && isUsingTelephoneAgent) {
        // If telephone agent is ON, must have at least one phone number
        if (Utils.isEmptyArray(phoneNumbers)) {
            isEmptyPhoneInput = true;
        } else {
            // Check if any phone number is empty
            for(let num of phoneNumbers) {
                const {dialCode, tel} = num;
                if (isInputTelephoneEmpty(dialCode, tel)) {
                    isEmptyPhoneInput = true;
                }
            }
        }
    }
    
    return { validateBeforeSubmit, isEmptyPhoneInput }
}


export const onSubmitChangeProjectProfile = async ({
    setIsLoading,
    error,
    setError,
    projectName,
    projectType,
    usingSynonym,
    usingIpAddressRestrict,
    ipAddressRange,
    enqueueSnackbar,
    userId,
    projectInuseDetail,
    setProjectInuseDetail,
    setIsShowDialogReload,
    listProjectInCorp,
    setListProjectInCorp,
    listProjectOfUser,
    setListProjectOfUser,
    setIsEdited,
    setIpAddressRange,
    setUsingIpAddressRestrict,
    isEmailResponseSettingFunction,
    setIsEmailResponseSettingFunction,
    projectMail,
    setProjectMail,
    projectAddressName,
    setProjectAddressName,
    senderEmailAddress,
    setSenderEmailAddress,
    ccEmailAddressList,
    setCcEmailAddressList,
    bccEmailAddressList,
    setBccEmailAddressList,
    signature,
    setSignature,
    corporationDetail,
    reloadTicketListByPanelType,
    setIsSendEmailVerify,
    setMailSettingDefault,
    isUsingTelephoneAgent,
    phoneNumbers,
    setPhoneNumbers
}) => {
    
    const { validateBeforeSubmit, isEmptyPhoneInput } = validateSubmitProjectProfile(error, projectType, isUsingTelephoneAgent, phoneNumbers)
    if (!validateBeforeSubmit || isEmptyPhoneInput) return;

    const emailDomain = Utils.getEmailDomain();
    const handleProjectEmailAddress = projectMail?.value?.trim() 
        ? `${projectMail.value.trim()}@${localStorageUtil.getCorporationDomain()}.${emailDomain}` 
        : '';

    let mailSetting = {
        isEmailResponseSettingFunction: isEmailResponseSettingFunction,
        projectMail: handleProjectEmailAddress,
        projectAddressName: projectAddressName?.value?.trim() || Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP,corporationDetail.name),
        senderEmailAddress: senderEmailAddress?.value?.trim() || handleProjectEmailAddress,
        ccEmailAddressList: ccEmailAddressList,
        bccEmailAddressList: bccEmailAddressList,
        signature: Utils.isValidJSONString(signature?.value)
            ? JSON.parse(signature.value)
            : (signature?.value == null ? "" : String(signature.value))
    };


    let ipAddressSetting = {
        usingIpAddressRestrict,
        ipAddressRange
    }

    const corporationLimitValue = Utils.convertJSONDataToObject(corporationDetail?.limitValue)

    let updateSettingData = {
        projectName,
        projectType,
        usingSynonym,
        ipAddressSetting,
        mailSetting,
        isUpdateWithEmailResponseFunctionOn : !!corporationLimitValue?.emailResponseFunction || Constant.STATUS_SERVICE_PERMISSION.OFF,
    }

    // apply telephoneAgentSetting
    if (isDisplayTelephoneAgentSetting(corporationDetail)) {
        let telephoneAgentSetting = {
            isUsingTelephoneAgent: isUsingTelephoneAgent,
            phoneNumbers: phoneNumbers.map(number => ({tel: number.tel, dialCode: number.dialCode}))
        }
        updateSettingData.telephoneAgentSetting = telephoneAgentSetting;
    }

    const updateProjectProfileParams = {
        projectProfile: JSON.stringify(updateSettingData),
        method: Constant.UPDATE_PROJECT_RESOURCE_METHOD.UPDATE_PROJECT_PROFILE,
        projectId: projectInuseDetail.id,
        userId,
        corporationId: projectInuseDetail.affiliationOrganization
    }

    setIsLoading(true);
    const updatedProject = await handleUpdateProjectResource(null, updateProjectProfileParams);
    setIsLoading(false);
    if (!updatedProject || !updatedProject.status) {
        let errorObject = { ...error };
        switch (updatedProject?.errorMessage) {
            case MessageCode.MSG_PROJECT_NAME_EMPTY:
                errorObject['projectName'] = I18n.get('MSG-CM-REQUIRED-INPUT');
                break;
            case MessageCode.MSG_UPDATE_PROFILE_PROJECT_NAME_MAXLENGTH_ERROR:
                errorObject['projectName'] = I18n.get('COMMSG022').replace('{{maxLength}}', '200');
                break;
            case MessageCode.MSG_UPDATE_PROFILE_PROJECT_NAME_DUPLICATE:
                errorObject['projectName'] = I18n.get('USER03MSG001');
                break;
            case MessageCode.MSG_UPDATE_IP_ADDRESS_WRONG_FORMAT:
                errorObject['ipAddressRange'] = I18n.get('IP_ADDRESS_FORMAT_WRONG');
                break;
            case MessageCode.MSG_UPDATE_IP_ADDRESS_MAX_EXCCED:
                errorObject['ipAddressRange'] = I18n.get('IP_ADDRESS_MAX_EXCCED').replace('{{maxIpAddress}}', '150');
                break;
            case MessageCode.MSG_UPDATE_IP_ADDRESS_EMPTY:
                errorObject['ipAddressRange'] = I18n.get('MSG-CM-REQUIRED-INPUT');
                break;
            case MessageCode.MSG_UPDATE_IP_ADDRESS_WRONG_FORMAT_DUPLICATE:
                errorObject['ipAddressRange'] = I18n.get('IP_ADDRESS_DUPLICATE');
                break;
            case MessageCode.MSG_EMAIL_TICKET_DUPLICATED_PROJECT_EMAIL:
                setProjectMail(prev => ({...prev, error: I18n.get('MSG_EMAIL_TICKET_DUPLICATED_PROJECT_EMAIL')}))
                errorObject['emailResponseSetting'] = I18n.get('MSG_EMAIL_TICKET_DUPLICATED_PROJECT_EMAIL');
                break;
            case MessageCode.MSG_TELEPHONE_TICKET_DUPLICATED_PROJECT_TEL_NUMBER:
                const invalidPhoneNumbers = Utils.convertJSONDataToObject(updatedProject?.data);
                if (!Utils.isEmptyArray(invalidPhoneNumbers)) {
                    setPhoneNumbers(prev => {
                        return prev.map(phone => {
                            if (invalidPhoneNumbers.includes(phone.tel)) {
                                return { ...phone, error: I18n.get('MSG_TELEPHONE_TICKET_DUPLICATED_PROJECT_TEL_NUMBER') }
                            }
                            return phone;
                        })
                    })
                }
                break;
            case MessageCode.DATA_CHANGED_PLEASE_RELOAD:
                setIsShowDialogReload(true);
                break;

            default:
                enqueueSnackbar(I18n.get('SYSMSG001'), {
                    variant: 'error',
                    autoHideDuration: 3000,
                });
                break;
        }

        setError(errorObject);
        return;
    }

    // Update prj inuse state
    let updatedProjectData = Utils.convertJSONDataToObject(updatedProject.data);
    let currentProjectInuseDetail = { ...projectInuseDetail };
    // name
    let newJsonProjectName = JSON.stringify({
        jp: {
            A: 'F',
            text: projectName
        }
    });
    currentProjectInuseDetail.name = newJsonProjectName;

    // type
    currentProjectInuseDetail.isDesk = updatedProjectData.isDesk;
    currentProjectInuseDetail.isPublic = updatedProjectData.isPublic;

    // Ipaddress Setting 
    if (Constant.PROJECT_SERVICE_TYPE.DESK_ON_PUBLIC_ON !== projectType) {
        ipAddressSetting = {
            usingIpAddressRestrict: false,
            ipAddressRange: ''
        }
        setUsingIpAddressRestrict(false);
        setIpAddressRange('');
    }

    // update emailResponseSettingData
    const {
        isEmailResponseSettingFunction: getIsEmailSetting,
        projectMail: getProjectMail,
        projectAddressName: getProjectAddressName,
        senderEmailAddress: getSenderEmailAddress,
        ccEmailAddressList: getCcEmailAddressList,
        bccEmailAddressList: getBccEmailAddressList,
        signature: getSignature
    } = getProjectOfEmailResponseSetting({mailSetting: updatedProjectData.mailSetting}, corporationDetail)

    setIsEmailResponseSettingFunction(getIsEmailSetting)
    setProjectMail(getProjectMail)
    setProjectAddressName(getProjectAddressName)
    setSenderEmailAddress(getSenderEmailAddress)
    setCcEmailAddressList(getCcEmailAddressList)
    setBccEmailAddressList(getBccEmailAddressList)
    setSignature(getSignature)
    setMailSettingDefault({
        projectMail: getProjectMail.value,
        projectAddressName: getProjectAddressName.value,
        senderEmailAddress: getSenderEmailAddress.value,
        signature: getSignature.value,
        ccEmailAddressList: getCcEmailAddressList,
        bccEmailAddressList: getBccEmailAddressList
    });

    // Re-update projectSetting
    let projectSettingClone = Utils.convertJSONDataToObject(projectInuseDetail.projectSetting);
    projectSettingClone.usingSynonym = usingSynonym;
    projectSettingClone.ipAddressSetting = ipAddressSetting;
    projectSettingClone.telephoneAgentSetting = updatedProjectData.telephoneAgentSetting
    currentProjectInuseDetail.projectSetting = JSON.stringify({
        ...projectSettingClone
    });

    // Re-update mailSetting
    currentProjectInuseDetail.mailSetting = JSON.stringify(updatedProjectData.mailSetting)
    
    setProjectInuseDetail(currentProjectInuseDetail);

    // Update project list atom
    let listProjectInCorpClone = cloneDeep(listProjectInCorp);
    let listProjectOfUserClone = cloneDeep(listProjectOfUser);

    listProjectInCorpClone.forEach(project => {
        if (project.id === currentProjectInuseDetail.id) {
            project.name = newJsonProjectName;
            project.isDesk = updatedProjectData.isDesk;
            project.isPublic = updatedProjectData.isPublic;
            project.projectSetting = currentProjectInuseDetail.projectSetting;
        }
    });

    listProjectOfUserClone.forEach(project => {
        if (project.id === currentProjectInuseDetail.id) {
            project.name = newJsonProjectName;
            project.isDesk = updatedProjectData.isDesk;
            project.isPublic = updatedProjectData.isPublic;
            project.projectSetting = currentProjectInuseDetail.projectSetting;
        }
    });

    listProjectInCorpClone = Utils.sortListByNameDictionaryASC(listProjectInCorpClone);
    setListProjectInCorp(listProjectInCorpClone);
    listProjectOfUserClone = Utils.sortListByNameDictionaryASC(listProjectOfUserClone);
    setListProjectOfUser(listProjectOfUserClone);

    enqueueSnackbar(I18n.get('MSG-CM-UPDATE-DATA-SUCCESS'), {
        variant: 'success',
        autoHideDuration: 3000
    });
    setIsEdited(false);

    const isSendEmailVerify = updatedProjectData?.isSendEmailVerify || false
    setIsSendEmailVerify(isSendEmailVerify)

    const isTriggerReloadPanel = updatedProjectData?.isTriggerReloadPanel || false
    if (isTriggerReloadPanel) {
        const panelTypes = [
            Constant.PANEL_TYPE.HELPDESK_TICKET_LIST,
            Constant.PANEL_TYPE.HELPDESK_TICKET_DETAIL,
            Constant.PANEL_TYPE.HELPDESK_CHATTHREAD,
            Constant.PANEL_TYPE.HELPDESK_TICKET_LIST_DRILLDOWN_AND_DETAIL_SEARCH
        ];
        for(let panelType of panelTypes) {
            reloadTicketListByPanelType({ panelType });
        }
    }

}


export const validateInputProjectProfile = (error, projectType) => {
    if (
        error.projectName ||
        ![
            Constant.PROJECT_SERVICE_TYPE.DESK_OFF,
            Constant.PROJECT_SERVICE_TYPE.DESK_ON_PUBLIC_OFF,
            Constant.PROJECT_SERVICE_TYPE.DESK_ON_PUBLIC_ON
        ].includes(projectType) ||
        error.ipAddressRange ||
        error.emailResponseSetting
    ) {
        return false;
    }
    return true;
};

export const handleCancelEditProjectProfile = (
    isEdited,
    isOpenConfirmReset,
    errors
) => {
    if (
        isEdited
    ) {
        isOpenConfirmReset(true);
    }
};

export const getStatusUsingSynonymProject = (projectInuseDetail) => {
    if (Utils.isEmptyObject(projectInuseDetail)) return false;
    const projectSetting = Utils.convertJSONDataToObject(projectInuseDetail?.projectSetting);
    return projectSetting?.usingSynonym ? true : false
}

export const getStatusUsingIpAddressRestrictProject = (projectInuseDetail) => {
    if (Utils.isEmptyObject(projectInuseDetail)) return false;
    const projectSetting = Utils.convertJSONDataToObject(projectInuseDetail?.projectSetting);
    if (Utils.isEmptyObject(projectSetting?.ipAddressSetting)) return false;
    return projectSetting?.ipAddressSetting?.usingIpAddressRestrict ? true : false
}

export const getIpAddressRangeProject = (projectInuseDetail) => {
    if (Utils.isEmptyObject(projectInuseDetail)) return '';
    const projectSetting = Utils.convertJSONDataToObject(projectInuseDetail?.projectSetting);
    if (Utils.isEmptyObject(projectSetting?.ipAddressSetting)) return '';
    return projectSetting?.ipAddressSetting?.ipAddressRange ? projectSetting?.ipAddressSetting?.ipAddressRange : '';
}

export const onChangeUsingIpAddressRestrict = (newUsingIpAddress, setUsingIpAddressRestrict, error, setError, setIsEdited) => {
    setUsingIpAddressRestrict(newUsingIpAddress);
    let errorObject = { ...error };
    if (!newUsingIpAddress && errorObject['ipAddressRange'] !== undefined) {
        delete errorObject['ipAddressRange'];
        setError(errorObject);
    }
    setIsEdited(true);
}

export const onChangeIpAddressRange = (newIpAddressRange, setIpAddressRange, setIsEdited) => {
    setIpAddressRange(newIpAddressRange);
    setIsEdited(true);
}

export const changeIpAddressRange = (newIpAddressRange, setIpAddressRange, error, setError, setIsEdited) => {
    let errorObject = { ...error };
    let errorMsg = ''
    setIpAddressRange(newIpAddressRange);

    if (!newIpAddressRange.trim()) {
        errorMsg = I18n.get('MSG-CM-REQUIRED-INPUT');
    } else {
        // Validate IP address format and max number of ip is 150
        let ips = Utils.getArrByBreakline(newIpAddressRange);
        let maxIpAddress = 150;
        if (ips?.length > maxIpAddress) {
            errorMsg = I18n.get('IP_ADDRESS_MAX_EXCCED').replace('{{maxIpAddress}}', maxIpAddress);
        } else {
            for (let index = 0; index < ips?.length; index++) {
                let ip = ips[index];
                if (ip.includes("/")) {
                    // validate subnet mask
                    let subnetMask = ip?.split("/");
                    // max of cidr is 32
                    if (typeof subnetMask[1] === 'string' && Utils.isNumberExludeStartZero(subnetMask[1])) {
                        if (Number(subnetMask[1]) > 32) {
                            errorMsg = I18n.get('IP_ADDRESS_FORMAT_WRONG');
                            break;
                        }
                    } else {
                        errorMsg = I18n.get('IP_ADDRESS_FORMAT_WRONG');
                        break;
                    }
                    if (!Utils?.validIpAddressFormat(subnetMask[0])) {
                        errorMsg = I18n.get('IP_ADDRESS_FORMAT_WRONG');
                        break;
                    }
                } else if (!Utils?.validIpAddressFormat(ip)) {
                    errorMsg = I18n.get('IP_ADDRESS_FORMAT_WRONG');
                    break;
                }
            }
            // Find duplicate data
            if (Utils.findDuplicateData(ips).length > 0) {
                errorMsg = I18n.get('IP_ADDRESS_DUPLICATE');
            }
        }
    }

    if (!Utils.isEmptyString(errorMsg)) errorObject['ipAddressRange'] = errorMsg;
    else delete errorObject['ipAddressRange'];
    setError(errorObject);

    if (errorMsg) {
        return;
    }
    setIsEdited(true);
}

export const getProjectOfEmailResponseSetting = (
    projectInuseDetail,
    corporationDetail
) => {    
    let initMailSetting = {
        isEmailResponseSettingFunction: false,
        projectMail: {value: '', error: ''},
        projectAddressName: {value: '', error: ''},
        senderEmailAddress: {value: '', error: ''},
        ccEmailAddressList: [],
        bccEmailAddressList: [],
        signature: {value: '', error: ''}
    }

    if (!projectInuseDetail || !corporationDetail) return initMailSetting;

    const corporationName = Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP,corporationDetail.name);

    const mailSetting = projectInuseDetail?.mailSetting ? Utils.convertJSONDataToObject(projectInuseDetail?.mailSetting) : {};
    
    if (Utils.isEmptyObject(mailSetting)) {
        return {
            ...initMailSetting,
            projectAddressName: {value: corporationName, error: ''},
        };
    };

    return {
        isEmailResponseSettingFunction: mailSetting.isEmailResponseSettingFunction,
        projectMail: {value: mailSetting.projectMail.split("@")[0], error: ''},
        projectAddressName: {value: mailSetting.projectAddressName || corporationName, error: ''},
        senderEmailAddress: {value: mailSetting.senderEmailAddress, error: ''},
        ccEmailAddressList: mailSetting.ccEmailAddressList.filter(item => !!item),
        bccEmailAddressList: mailSetting.bccEmailAddressList.filter(item => !!item),
        signature: {value: mailSetting.signature, error: ''}
    }
}

export const isDisplayTelephoneAgentSetting = (corporationDetail) => {
    if (!corporationDetail) return false;

    return (
        Utils.isEnableSettingTelephoneAgent(corporationDetail) &&
        corporationDetail?.contractType === Constant.CORPORATION_CONTRACT_TYPE.PREMIUM
    );
};